/**
 * Handles displaying a "floatingLabel" label on fields,
 * which changes position when user focuses, changes, or adds input to a field.
 */

export default class FloatingLabels {
    constructor(query) {
        let formRows = document.querySelectorAll(query);

        [].forEach.call(formRows, this.setupField.bind(this));
    }

    setupField(formRow) {
        let input = formRow.querySelector('input, select');

        input.addEventListener('focus', this.setFloating.bind(this, formRow));
        input.addEventListener('input', this.setFloating.bind(this, formRow));
        input.addEventListener('change', this.toggleFloating.bind(this, input, formRow));
        input.addEventListener('external:change', this.toggleFloating.bind(this, input, formRow));
        input.addEventListener('blur', this.toggleFloating.bind(this, input, formRow));

        if (input.value || (window.SFRA.supportsPlaceholderShown && input.placeholder && !input.matches(':placeholder-shown'))) {
            this.setFloating(formRow);
        }

        //Sets methods on the input field itself.
        input.floatingLabel = {
            setFloating: this.setFloating.bind(this, formRow),
            unsetFloating: this.unsetFloating.bind(this, formRow),
            toggleFloating: this.toggleFloating.bind(this, input, formRow)
        };
    }

    setFloating(formRow) {
        formRow.classList.add('set--floating-label');
    }

    unsetFloating(formRow) {
        formRow.classList.remove('set--floating-label');
    }

    toggleFloating(input, formRow) {
        formRow = formRow || input.closest('[data-floating-label]');

        if (formRow) {
            if (input.value.trim()) {
                this.setFloating(formRow);
            } else {
                this.unsetFloating(formRow, input);
            }
        }
    }
}
